import { render, staticRenderFns } from "./Onepage.vue?vue&type=template&id=d1623d9c&scoped=true"
import script from "./Onepage.vue?vue&type=script&lang=js"
export * from "./Onepage.vue?vue&type=script&lang=js"
import style0 from "./Onepage.vue?vue&type=style&index=0&id=d1623d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1623d9c",
  null
  
)

export default component.exports